import { useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import PurchasePreview from '../../../ShutterStock/components/PurchasePreview';
import PurchaseInfo from '../PurchaseInfo';
import { useSelectedAsset } from '../../getty-selectors';

const PurchaseBox = styled.div`
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  .preview {
    max-width: 100%;
    max-height: 100%;
  }
`;

export default ({ retrieveProduct, source, actions }) => {
  const dispatch = useDispatch();
  const { selectedAsset } = useSelectedAsset(source);
  useEffect(() => {
    retrieveProduct();
  }, [retrieveProduct]);

  useEffect(() => {
    if (selectedAsset?.id && actions?.retrieveAssetDetailsAction) {
      dispatch(actions.retrieveAssetDetailsAction({ id: selectedAsset.id }));
    }
  }, [actions, dispatch, selectedAsset.id]);
  return (
    <PurchaseBox>
      <PurchasePreview asset={selectedAsset} isVideo={selectedAsset?.isVideo} />
      <PurchaseInfo source={source} actions={actions} />
    </PurchaseBox>
  );
};
